/**
 * @generated SignedSource<<f79890c4c2c65c171926a30c9d240f4c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AutomationChatLink_Query$variables = {
  chatMessageId: string;
};
export type AutomationChatLink_Query$data = {
  readonly chatMessage: {
    readonly chatAutomation?: {
      readonly jobAutomatedMessageSchedule: {
        readonly job: {
          readonly firm: {
            readonly self: boolean | null | undefined;
          } | null | undefined;
          readonly incognito: boolean | null | undefined;
          readonly slug: string | null | undefined;
        };
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type AutomationChatLink_Query = {
  response: AutomationChatLink_Query$data;
  variables: AutomationChatLink_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "chatMessageId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "chatMessageId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "incognito",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "self",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AutomationChatLink_Query",
    "selections": [
      {
        "alias": "chatMessage",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ChatAutomation",
                "kind": "LinkedField",
                "name": "chatAutomation",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JobAutomatedMessageSchedule",
                    "kind": "LinkedField",
                    "name": "jobAutomatedMessageSchedule",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Job",
                        "kind": "LinkedField",
                        "name": "job",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Firm",
                            "kind": "LinkedField",
                            "name": "firm",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "ChatMessage",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AutomationChatLink_Query",
    "selections": [
      {
        "alias": "chatMessage",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ChatAutomation",
                "kind": "LinkedField",
                "name": "chatAutomation",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JobAutomatedMessageSchedule",
                    "kind": "LinkedField",
                    "name": "jobAutomatedMessageSchedule",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Job",
                        "kind": "LinkedField",
                        "name": "job",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Firm",
                            "kind": "LinkedField",
                            "name": "firm",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "ChatMessage",
            "abstractKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a47015a0c86313cac98f164ac2b6cf6e",
    "id": null,
    "metadata": {},
    "name": "AutomationChatLink_Query",
    "operationKind": "query",
    "text": "query AutomationChatLink_Query(\n  $chatMessageId: ID!\n) {\n  chatMessage: node(id: $chatMessageId) {\n    __typename\n    ... on ChatMessage {\n      chatAutomation {\n        jobAutomatedMessageSchedule {\n          job {\n            slug\n            incognito\n            firm {\n              self\n              id\n            }\n            id\n          }\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d30fa3663c66268bfae1074392daa30b";

export default node;
